import React from "react";

import { PRACTICE_SLUG } from "models";

import { PracticeList } from "pages/admin/verifications/components/lists/PracticeList";
import { FertilizerTable } from "pages/admin/verifications/components/misc/FertilizerTable";
import { FertilizerTimeline } from "pages/admin/verifications/components/misc/FertilizerTimeline";

export const FertilizerList = ({ farmId }: { farmId: string }) => (
  <PracticeList
    farmId={farmId}
    practiceSlugs={[PRACTICE_SLUG.MINERAL_FERTILIZERS, PRACTICE_SLUG.ORGANIC_FERTILIZERS]}
    renderTimeline={(fieldId) => <FertilizerTimeline fieldId={fieldId} />}
    renderExpandedContent={(field) => <FertilizerTable field={field} farmId={farmId} />}
  />
);
